module.exports = __webpack_public_path__ + "static/media/35-5.1639d58c.mp3";